import { Icon } from "@iconify/react/dist/iconify.js";
import { Tooltip } from "devextreme-react";
import moment from "moment/min/moment-with-locales";

export const DefaultDateFormat = {
  DateTime24Format: "dd/MM/yyyy HH:mm",
  DateTimeFullFormat: "dd/MM/yyyy HH:mm:ss",
  DateTimeFullYMDFormat: "yyyy/MM/dd HH:mm:ss",
  DateTimeFullYMDHHmmFormatSql: "yyyy-MM-dd HH:mm",
  DateFormat: "dd/MM/yyyy",
  DateFormat1: "MM/dd/yyyy",
  DateFormatMonthName: "dd-MMM-yyyy",
  TimeFormat: "HH:mm",
  DayMonthDateFormat: "Do MMM",
  DayMonthYYDateFormat: "Do MMM YY",
  DayMonthYearDateFormat: "Do MMM YYYY",
  DayMonthYYTimeDateFormat: "Do MMM YY h:mm:ss a",
  DayMonthYearTimeDateFormat: "Do MMM YYYY h:mm:ss a",

  MomentDisplayDateTime24Format: "DD/MM/yyyy HH:mm",
  MomentDisplayDateTime24AMPFormat: "DD/MM/yyyy HH:mm A",
  MomentDisplayDateTime24MonthNameFormat: "DD/MMM/yyyy HH:mm",
  MomentDisplayDateTimeAMPMFullFormat: "DD/MM/yyyy hh:mm A",
  MomentDisplayDateTimeFullFormat: "DD/MM/yyyy hh:mm:ss",
  MomentDisplayDateFormat: "DD/MM/yyyy",
  MomentDisplayTimeFormat: "HH:mm",
  MomentDateFormat: "YYYY-MM-DDThh:mm:ss",

  SqlDateTime24Format: "YYYY-MM-DD HH:mm",
  SqlDateTimeFullFormat: "YYYY-MM-DD hh:mm:ss",
  SqlDateFormat: "YYYY-MM-DD",
  SqlTimeFormat: "HH:mm",
  SqlStartDateFormat: "YYYY-MM-DD 00:00:00",
  SqlEndDateFormat: "YYYY-MM-DD 23:59:59",

  GridDateTime24Format: "dd/MM/yyyy HH:mm",
  GridDateFormat: "MM/dd/yyyy",
  GridDateTimeHHmmFormat: "MM/dd/yyyy HH:mm",
  GridDateTimeHHmmssFormat: "MM/dd/yyyy HH:mm:ss",
  GridDateTimeAMPMFormat: "MM/dd/yyyy h:mm:ss a",
  GridTimeHHmmFormat: "HH:mm",
  GridTimeHHmmssFormat: "HH:mm:ss",
  GridTimeAMPMFormat: "h:mm:ss a",
  GridDayMonthYearDateFormat: "dd-MMM-yyyy",
};
export const DateFilter = {
  CurrentDateTime: new Date(),
  StartDateTime: new Date(moment(new Date()).startOf("day")),
  EndDateTime: new Date(moment(new Date()).endOf("day")),
};
export const CurrencyIcon = {
  ruppesFormat: "fas fa-rupee-sign",
  dollarFormat: "fas fa-dollar-sign",
};
export const PrecisionFormats = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
};
export const PercentIcon = {
  Normal: "fas fa-percent",
  Xs: "fas fa-percent fa-xs",
  Sm: "fas fa-percent fa-sm",
  Lg: "fas fa-percent fa-lg",
};

export const LoginAssetType = {
  Web: 1,
};
export const ApplicationType = {
  ApplicationTypeId: 1,
  ApplicationTypeName: "Web Portal",
  ApplicationVersion: "1.0",
};

export const MachineName = "Web";

export const RegEx = {
  MobileNumber: /^\d{10}$/,
  Numeric: /^[0-9\b]+$/,
  AlphaNumeric: /^[A-Za-z0-9-]*$/,
  Decimal2Digit: /^\d*(\.\d{0,2})?$/,
  DecimalRulePattern2Digit: /^\\d{0,5}(\\.{0,1})\\d{0,2}$/,
  Mobile: /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/,
  Email:
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PanNumber: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
  AadharNumber: /^\d{12}$/,
  Lowercase: /[a-z]/,
  Uppercase: /[A-Z]/,
  Specialcharacters: /[!@#$%^&*]/,
};

export const AssetStatusType = {
  Asset: 1001,
  AssetRequest: 1002,
  AssetMovement: 1003,
  AssetScrap: 1004,
  AssetPurchaseRequest: 1005,
  RequestForAssetPurchase: 1006,
  RequestForAssetServiceOrder: 1007,
  AssetDispatch: 1008,
  AssetAcknowledgement: 1009,
  AssetCondition: 1010,
  SAP: 1011,
  AssetMaterialMovement: 1012,
  MaterialMovementOrder: 1013,
  ImportSapStatus: 1014,
  ActionOnRequest: 1015,
};

export const AssetSubStatus = {
  Available: 10001,
  InTransit: 10002,
  Allocated: 10003,
  Returned: 10004,
  New: 10005,
  Active: 10006,
  Maintenance: 10007,
  NeedsRepair: 10008,
  NotinUse: 10009,
  OutofService: 10010,
  Obsolete: 10011,
  LostMissing: 10012,
  Scrapped: 10013,
  AssetRequestPending: 10014,
  AssetRequestApproved: 10015,
  AssetMove: 10016,
  SendforPR: 10017,
  AssetRequestSendforApproval: 10018,
  AssetMovementInDraftMode: 10019,
  AssetMovementSendforApproval: 10020,
  AssetMovementApproved: 10021,
  AssetScrapInDraftMode: 10022,
  AssetScrapSentForApproval: 10023,
  AssetScrapApproved: 10024,
  AssetRequestBackToDraft: 10025,
  AssetRequestRecall: 10026,
  AssetScrapBackToDraft: 10027,
  AssetScrapRecall: 10028,
  AssetPurchaseRequestDrafted: 10029,
  AssetPurchaseRequestApproved: 10030,
  AssetPurchaseRequestSentforApproval: 10031,
  AssetPurchaseRequestBacktoDraft: 10032,
  AssetPurchaseRequestRecall: 10033,
  AssetRequestApprovalPending: 10034,
  AssetRequestPartiallyComlpeted: 10035,
  AssetRequestApprovalCompleted: 10036,
  AssetMovement: 10039,
  AssetPR: 10040,
  AssetRequestPartiallyApproved: 10041,
  AssetRequestCompleted: 10042,
  AssetRequestPr: 10043,
  AssetRequestMovement: 10044,
  AssetMovementRequestRecall: 10037,
  RequestForAssetPurchasePending: 10045,
  RequestForAssetPurchaseInDraftMode: 10046,
  RequestForAssetPurchaseSendForApproval: 10047,
  RequestForAssetPurchaseApproved: 10048,
  RequestForAssetServiceOrderPending: 10049,
  RequestForAssetServiceOrderInDraftMode: 10050,
  RequestForAssetServiceOrderSendForApproval: 10051,
  RequestForAssetServiceOrderApproved: 10052,
  RequestForAssetPurchaseReCall: 10056,
  RequestForAssetServiceOrderReCall: 10057,
  RequestForAssetPurchaseBacktoDraft: 10058,
  RequestForAssetServiceOrderBacktoDraft: 10059,
  AssetDispatchPending: 10053,
  AssetDispatchJobStarted: 10054,
  AssetDispatchJobEnded: 10055,
  AssetAcknowledgePending: 10060,
  AssetAcknowledged: 10061,
  SendForServiceOrder: 10067,
  PendingSAPSync: 10068,
  PODetailsPending: 10069,
  ServiceDetailsPending: 10071,
  PendingForVerification: 10070,
  AssetPurchaseRequestPending: 10072,
  AssetMaterialMovementInDraftMode: 10073,
  AssetMaterialMovementSentForApproval: 10074,
  AssetMaterialMovementRecall: 10075,
  AssetMaterialMovementBackToDraft: 10076,
  AssetMaterialMovementApproved: 10077,
  EWayBilldetailsPending: 10078,
  MaterialMovementOrderPending: 10079,
  MaterialMovementOrderInDraftMode: 10080,
  MaterialMovementOrderSentForApproval: 10081,
  MaterialMovementOrderApproved: 10082,
  MaterialMovementOrderRecall: 10083,
  MaterialMovementOrderBackToDraft: 10084,
  ImportSapPending: 10085,
  ImportSapInDraftMode: 10086,
  ImportSapApproved: 10087,
  GRNPending: 10088,
  GRNReceived: 10091,
  SAPMovementPending: 10089,
  PendingForAcknowledgement: 10090,
  AssetMovementPending: 10038,
  Onboarded: 10092,
  AssetMaterialMovementPending: 10098,
  ActionOnRequestInDraftMode: 10093,
  ActionOnRequestSentForApproval: 10094,
  ActionOnRequestApproved: 10095,
  ActionOnRequestBackToDraft: 10096,
  ActionOnRequestRecall: 10097,
  ActionPartiallyApproved: 10099,
  ActionOnRequestPending: 10100,
};

export const Features = {
  AssetRequest: 56,
  AssetMovement: 81,
  AssetScrap: 57,
  MaterialMovementRequest: 123,
  MaterialMovementOrder: 124,
  AssetPurchase: 109,
  AssetHire: 110,
};

export const AssetQuotationType = {
  RequestForAssetPurchase: 1,
  RequestForAssetServiceOrder: 2,
};

export const IconWithTooltip = ({
  id,
  icon,
  className,
  title,
  tooltip,
  onClick,
  style = {},
}) => {
  return (
    <>
      <span id={id} style={{ display: "inline-block" }}>
        <Icon
          icon={icon}
          className={className}
          title={title}
          tooltip={tooltip}
          style={{ ...style }}
          onClick={onClick}
        />
      </span>
      <Tooltip
        target={`#${id}`}
        showEvent="mouseenter"
        hideEvent="mouseleave"
        showOnTargetHover={true}
        wrapperAttr={{ class: "icon-tooltip" }}
        position="top"
        contentRender={() => <div>{title}</div>}
      />
    </>
  );
};
